require(['id'], function(ID){
  ID(window);
});

define("main", function(){});

